import React from 'react';
import styled from 'styled-components';

const Avatar = styled.div`
  background-color: ${({ theme }) => theme.palette.custom.borderAccent};
  width: 8px;
  height: 48px;
  border-radius: 2px;
`;
const CardAvatar = () => <Avatar />;

export default CardAvatar;
